import styled from 'styled-components';

export const PageContainer = styled.div`
  min-height: 100vh;
  background-color: #f7f9fc;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
`;

export const Logo = styled.img`
  height: 48px;
  margin-bottom: 2rem;
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 2rem;
  width: 100%;
  max-width: 600px;
`;

export const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  color: #222;
  text-align: center;
  margin-bottom: 0.5rem;
`;

export const Subtitle = styled.p`
  font-size: 1rem;
  color: #666;
  text-align: center;
  margin-bottom: 0.5rem;
`;

export const InfoText = styled.p`
  font-size: 0.875rem;
  color: #888;
  text-align: center;
  margin-bottom: 1.5rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 0.25rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.875rem 1rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #049366;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  ${({ variant = 'primary' }) =>
    variant === 'primary'
      ? `
        background-color: #049366;
        color: #fff;
        
        &:hover {
          background-color: #038454;
        }
        
        &:disabled {
          background-color: #ccc;
          cursor: not-allowed;
        }
      `
      : `
        background-color: #f5f5f5;
        color: #333;
        
        &:hover {
          background-color: #eee;
        }
      `}
`;

export const ComprasList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const CompraCard = styled.div`
  background: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CompraInfo = styled.div`
  flex: 1;
`;

export const CompraNome = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #222;
  margin: 0 0 0.25rem 0;
`;

export const CompraDetalhes = styled.p`
  font-size: 0.875rem;
  color: #666;
  margin: 0;
`;

export const CompraValor = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #049366;
`;

export const ReembolsoButton = styled.button`
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  background-color: #049366;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    background-color: #038454;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const ReembolsoButtonDisabled = styled.button`
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  background-color: #ddd;
  color: #888;
  border: none;
  border-radius: 6px;
  cursor: not-allowed;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const GarantiaExpiradaMsg = styled.p`
  font-size: 0.75rem;
  color: #dc3545;
  margin: 0.5rem 0 0 0;
  font-style: italic;
`;

export const CodeInputContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin: 1.5rem 0;
`;

export const CodeInput = styled.input`
  width: 48px;
  height: 56px;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  border: 2px solid #ddd;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #5B5FC7;
  }
`;

export const ErrorMessage = styled.p`
  color: #dc3545;
  font-size: 0.875rem;
  text-align: center;
  margin-top: 0.5rem;
`;

export const SuccessMessage = styled.p`
  color: #049366;
  font-size: 0.875rem;
  text-align: center;
  margin-top: 0.5rem;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #049366;
  font-size: 0.875rem;
  cursor: pointer;
  margin-top: 1rem;
  text-decoration: underline;

  &:hover {
    color: #038454;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 2rem;
  color: #666;
`;

export const SuccessContainer = styled.div`
  text-align: center;
  padding: 2rem 0;
`;

export const SuccessIcon = styled.div`
  width: 64px;
  height: 64px;
  background-color: #049366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  color: #fff;
  font-size: 2rem;
`;

export const SuccessTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 0.5rem;
`;

export const SuccessText = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 1.5rem;
`;

export const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
